import { Alert } from 'react-bootstrap'
import * as H from 'history'
import  React from 'react'
import { ClaimModel } from '../../../../models/ClaimModel'
import { MarketingConsultant } from '../../../../models/MarketingConsultant'
import { MarketingConsultantEntry } from '../../../../models/MarketingConsultantEntry'
import { Option } from '../../../../models/Option'
import {
  AcnField, AddressField, BooleanRadioButtonField, DateField, EmailField, MultiLineField, PhoneField, TextField, TextSelectField, validateFields, yesNoDataSource,
} from '../../../../shared/fields'
import { SalutationField } from '../../../../shared/fields/SalutationField'
import { ShowIf } from '../../../../shared/fields/ShowIf'
import { ISection, Table, TableColumn } from '../../../../shared/table'
import { formatNumber, getAddressString } from '../../../../shared/Utility'
import {
  calculateMarketingConsultantTotal, marketingConsultantEntryColumns, MarketingConsultantEntryDetails, sortMarketingConsultantEntries,
} from './MarketingConsultantEntryDetails'
import { Icon } from '../../../../shared/Icon'

export const marketingConsultantColumns = (history: H.History, claimId: string, preview: boolean): TableColumn<MarketingConsultant>[] => [
  { name: "Consultant's name", content: (d) => `${d.firstName} ${d.lastName}` },
  { name: 'Trading name', content: (d) => d.tradingName, responsive: 'md' },
  { name: 'Claimed amount', content: (d) => `$${formatNumber(calculateMarketingConsultantTotal(d.entries))}` },
  { name: 'Address', content: (d) => getAddressString(d.physicalAddress), printOnly: true },
  { name: 'Mobile', content: (d) => d.mobile, printOnly: true },
  { name: 'Telephone', content: (d) => d.phone, printOnly: true },
  { name: 'Email ', content: (d) => d.email, printOnly: true },
  { name: 'Web site', content: (d) => d.website, printOnly: true },
  { name: 'Relationship', content: (d) => d.relationship, printOnly: true },
  { name: 'Description', content: (d) => d.description, printOnly: true },
  {
    name: '', content: (d) => (preview ? '' : <a href="#" onClick={(e) => { e.preventDefault(); history.push(`/claim/${claimId}/prepare/marketingconsultants/${d.id}`) }}>Edit</a>),
  },
]

export const calculateAllConsultantsTotal = (consultants: MarketingConsultant[]): number => {
  let total = 0
  for (const c of consultants) {
    total += calculateMarketingConsultantTotal(c.entries)
  }
  return total
}

export interface MarketingConsultantDetailsProps {
    id: string
    model: MarketingConsultant
    onChange: { (v: Partial<MarketingConsultant>): any }
    preview?: boolean
    claim: ClaimModel
    addressCountries: Option<string>[]
    markets: Option<string>[]
}

export interface MarketingConsultantDetailsState {
}

export class MarketingConsultantDetails extends React.Component<MarketingConsultantDetailsProps, MarketingConsultantDetailsState> implements ISection {
    title: SalutationField
    firstName: TextField
    lastName: TextField
    tradingName: TextField
    acn: AcnField
    physicalAddress: AddressField
    postalAddressDifferent: BooleanRadioButtonField
    postalAddress: AddressField
    phone: PhoneField
    mobile: PhoneField
    email: EmailField
    website: TextField
    relationship: TextSelectField
    otherRelationship: TextField
    consultedFrom: DateField
    consultedTo: DateField
    description: MultiLineField
    table: Table<MarketingConsultantEntry>

    constructor(props: MarketingConsultantDetailsProps) {
      super(props)

      this.state = {
      }
    }

    validate = (callback: { (res: boolean): any }) => {
      validateFields((res) => callback(res),
        this.title,
        this.firstName,
        this.lastName,
        this.tradingName,
        this.acn,
        this.physicalAddress,
        this.postalAddressDifferent,
        this.postalAddress,
        this.phone,
        this.mobile,
        this.email,
        this.website,
        this.relationship,
        this.otherRelationship,
        this.consultedFrom,
        this.consultedTo,
        this.description)
    }

    saveAndClose = (callback?: { (res: boolean): any }) => {
      callback && callback(true)
    }

    isDuplicate() {
      const key = (`${this.props.model.firstName}|${this.props.model.lastName}|${this.props.model.tradingName}`).toLowerCase()

      return this.props.claim.marketingConsultants.filter((r) => (`${r.firstName}|${r.lastName}|${r.tradingName}`).toLowerCase() == key && r.id != this.props.model.id).length > 0
            || this.props.claim.representations.filter((r) => (`${r.firstName}|${r.lastName}|${r.registeredName}`).toLowerCase() == key).length > 0
    }

    isSameAcnAsApplicant(): boolean {
      return this.props.model.acn && this.props.claim.acn && this.props.claim.acn.replace(/\s/g, '') == this.props.model.acn.replace(/\s/g, '')
    }

    render() {
      const relationshipDataSource = [
        { value: 'Branch office', label: 'Branch office' },
        { value: 'Director / Shareholder', label: 'Director / Shareholder' },
        { value: 'Distributor', label: 'Distributor' },
        { value: 'Related / Associated company', label: 'Related / Associated company' },
        { value: 'Relative', label: 'Relative' },
        { value: 'Other', label: 'Other' },
      ]

      let { relationship } = this.props.model
      if (relationship && relationshipDataSource.filter((r) => r.value == relationship).length == 0) {
        relationship = 'Other'
      }

      const entryColumns = [...marketingConsultantEntryColumns(this.props.markets)]

      const invalidRows = this.props.model.entries.filter((r) => r.invalid).length > 0
      if (invalidRows) {
        entryColumns.splice(0, 0, { name: '', content: (d) => (d.invalid ? <Icon type="warning" /> : <span />) })
      }

      return (
        <>
          <SalutationField
            ref={(r) => this.title = r}
            id={`${this.props.id}-title`}
            label="Title"
            value={this.props.model.title}
            onChange={(title) => this.props.onChange({ title })}
            required
            preview={this.props.preview}
          />
          <div className="clearfix">
            <TextField
              ref={(r) => this.firstName = r}
              id={`${this.props.id}-firstName`}
              label="First Name"
              value={this.props.model.firstName}
              onChange={(firstName) => this.props.onChange({ firstName })}
              required
              maxLength={50}
              preview={this.props.preview}
              className="float-left mr-3"
            />
            <TextField
              ref={(r) => this.lastName = r}
              id={`${this.props.id}-lastName`}
              label="Last (Family) name"
              value={this.props.model.lastName}
              onChange={(lastName) => this.props.onChange({ lastName })}
              required
              maxLength={50}
              preview={this.props.preview}
              className="float-left"
            />
          </div>
          <TextField
            ref={(r) => this.tradingName = r}
            id={`${this.props.id}-tradingName`}
            label="Trading name"
            value={this.props.model.tradingName}
            onChange={(tradingName) => this.props.onChange({ tradingName })}
            required
            maxLength={80}
            preview={this.props.preview}
            errorMessage={this.isDuplicate() ? 'This consultant name and trading name are identical to another Marketing Consultant, or an Overseas Representative, for the applicant. Please change either the consultant name or trading name to distinguish between the two entities' : ''}
          />
          <AcnField
            ref={(r) => this.acn = r}
            id={`${this.props.id}-acn`}
            label="ASIC Number (ACN)"
            value={this.props.model.acn}
            onChange={(acn) => this.props.onChange({ acn })}
            block={false}
            preview={this.props.preview}
            errorMessage={this.isSameAcnAsApplicant() ? "Australian Company Number cannot be the same as applicant's ACN" : ''}
          />
          <AddressField
            ref={(r) => this.physicalAddress = r}
            id={`${this.props.id}-physicalAddress`}
            label="Business address (physical address)"
            value={this.props.model.physicalAddress}
            onChange={(physicalAddress) => this.props.onChange({ physicalAddress })}
            required
            preview={this.props.preview}
            countries={this.props.addressCountries}
          />
          <BooleanRadioButtonField
            ref={(r) => this.postalAddressDifferent = r}
            id={`${this.props.id}-postalAddressDifferent`}
            label="Is your postal address different to the address above?"
            value={this.props.model.postalAddressDifferent}
            onChange={(postalAddressDifferent) => this.props.onChange({ postalAddressDifferent })}
            dataSource={yesNoDataSource}
            required
            preview={this.props.preview}
          />
          <AddressField
            ref={(r) => this.postalAddress = r}
            id={`${this.props.id}-postalAddress`}
            label="Postal address"
            value={this.props.model.postalAddress}
            onChange={(postalAddress) => this.props.onChange({ postalAddress })}
            required={this.props.model.postalAddressDifferent}
            visible={this.props.model.postalAddressDifferent || false}
            preview={this.props.preview}
            countries={this.props.addressCountries}
          />
          <PhoneField
            ref={(r) => this.phone = r}
            id={`${this.props.id}-phone`}
            label="Telephone number (e.g. +61 2 9999 9999)"
            value={this.props.model.phone}
            onChange={(phone) => this.props.onChange({ phone })}
            required
            block={false}
            preview={this.props.preview}
          />
          <PhoneField
            ref={(r) => this.mobile = r}
            id={`${this.props.id}-mobile`}
            label="Mobile phone number (e.g. +61 499 999 999)"
            value={this.props.model.mobile}
            onChange={(mobile) => this.props.onChange({ mobile })}
            block={false}
            preview={this.props.preview}
          />
          <EmailField
            ref={(r) => this.email = r}
            id={`${this.props.id}-email`}
            label="Email"
            value={this.props.model.email}
            onChange={(email) => this.props.onChange({ email })}
            required
            maxLength={80}
            preview={this.props.preview}
          />
          <TextField
            ref={(r) => this.website = r}
            id={`${this.props.id}-website`}
            label="Business website address"
            value={this.props.model.website}
            onChange={(website) => this.props.onChange({ website })}
            required={false}
            maxLength={80}
            preview={this.props.preview}
          />
          <ShowIf condition={!this.props.preview}>
            <TextSelectField
              ref={(r) => this.relationship = r}
              id={`${this.props.id}-relationship`}
              label="What is the consultant’s relationship to you?"
              value={relationship}
              onChange={(relationship) => this.props.onChange({ relationship })}
              dataSource={relationshipDataSource}
              required
              preview={this.props.preview}
            />
            <TextField
              ref={(r) => this.otherRelationship = r}
              id={`${this.props.id}-otherRelationship`}
              label="Other relationship"
              value={this.props.model.relationship == 'Other' ? '' : this.props.model.relationship}
              onChange={(relationship) => this.props.onChange({ relationship })}
              visible={relationship == 'Other'}
              required={relationship == 'Other'}
              maxLength={40}
              preview={this.props.preview}
            />
          </ShowIf>
          <div className="clearfix">
            <DateField
              ref={(r) => this.consultedFrom = r}
              id={`${this.props.id}-consultedFrom`}
              label="Consulted from"
              value={this.props.model.consultedFrom}
              onChange={(consultedFrom) => this.props.onChange({ consultedFrom })}
              required
              preview={this.props.preview}
              className="float-left mr-3"
            />
            <DateField
              ref={(r) => this.consultedTo = r}
              id={`${this.props.id}-consultedTo`}
              label="to"
              value={this.props.model.consultedTo}
              onChange={(consultedTo) => this.props.onChange({ consultedTo })}
              required
              preview={this.props.preview}
              className="float-left"
            />
          </div>
          <MultiLineField
            ref={(r) => this.description = r}
            id={`${this.props.id}-description`}
            label="Describe your consultant's activities"
            value={this.props.model.description}
            onChange={(description) => this.props.onChange({ description })}
            required
            maxLength={255}
            preview={this.props.preview}
          />

          <h3>Marketing consultant expenses</h3>
          <div style={{ display: this.props.preview ? 'none' : '' }}>
            <p className="mt-3">The basis for any apportionment of expenses should be entered in the Notes field.</p>
            <div className="mt-3 mb-3">
              <Alert className="emdg-page-alerts">
                <p>This category is capped at $50,000 but you should claim all eligible expenses.</p>
              </Alert>
            </div>
          </div>

          <Table<MarketingConsultantEntry>
            id="table"
            label="Schedule 1B: Marketing consultants"
            ref={(r) => this.table = r}
            value={this.props.model.entries.sort((a, b) => sortMarketingConsultantEntries(a, b))}
            onChange={(entries) => this.props.onChange({ entries })}
            columns={entryColumns}
            renderSection={(p, i) => <MarketingConsultantEntryDetails {...p} markets={this.props.markets} claim={this.props.claim} preview={this.props.preview} />}
            importUrl="/api/marketingconsultant/import"
            exportUrl="/api/marketingconsultant/export"
            match={(a, b) => a.id == b.id}
            total={calculateMarketingConsultantTotal}
            allowEdit
            allowImport
            invalidRows={invalidRows}
          />
        </>
      )
    }
}
